const DEFAULT = 'https://docs.zenprotocol.com/apps/oracle/oracle-guide';

const DOCS = {
  DEFAULT,
};

export default DOCS;
